import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const hasConsent = () => !!localStorage.getItem("fod_cookie_consent");

export const MobileStickyCta = () => {
    const [scrolled, setScrolled] = useState(false);
    const [consent, setConsent] = useState(hasConsent);

    useEffect(() => {
        const onScroll = () => {
            const footer = document.querySelector('[data-testid="site-footer"]');
            const nearFooter = footer && footer.getBoundingClientRect().top < window.innerHeight;
            setScrolled(window.scrollY > window.innerHeight * 0.8 && !nearFooter);
        };
        const onConsent = () => setConsent(hasConsent());
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        window.addEventListener("fod-consent", onConsent);
        return () => {
            window.removeEventListener("scroll", onScroll);
            window.removeEventListener("fod-consent", onConsent);
        };
    }, []);

    const show = scrolled && consent;
    return (
        <div
            data-testid="mobile-sticky-cta"
            aria-hidden={!show}
            className={`md:hidden fixed inset-x-0 bottom-0 z-[60] px-4 pt-3 pb-[max(12px,env(safe-area-inset-bottom))] bg-white/90 backdrop-blur-md border-t border-border-default transition-[transform,opacity] duration-300 ${
                show ? "translate-y-0 opacity-100" : "translate-y-full opacity-0 pointer-events-none"
            }`}
        >
            <Link
                to="/simulateur"
                tabIndex={show ? 0 : -1}
                data-testid="mobile-sticky-cta-btn"
                className="w-full h-12 inline-flex items-center justify-center gap-2 rounded-md bg-gold text-navy text-base font-semibold active:scale-[0.98] transition-transform"
            >
                Simuler mes économies <ArrowRight size={18} />
            </Link>
        </div>
    );
};
